import { Injectable } from '@angular/core';
import {
  RolesPermissions,
  SpaceAccessControl,
  SpaceAction,
  SpaceUserRole,
} from '@interfaces/space-access-control.types';

@Injectable({ providedIn: 'root' })
export class SpaceRolePermissionService {
  constructor() {}

  /* Check if a user with a specific role has permission to perform a given action in a space
   * @param role - The role of the user in the space
   * @param action - The action to check permission for
   * @returns boolean - True if the user has permission, false otherwise
   */
  public checkSpaceUserPermission(role: SpaceUserRole, action: SpaceAction): boolean {
    const permissions = RolesPermissions[role] || [];
    return permissions.includes(action);
  }

  public getSpaceAccessControl(role: SpaceUserRole): SpaceAccessControl {
    return {
      role,
      permissions: RolesPermissions[role] || [],
    };
  }
}
